import { getMessage } from '@locaweb/design-system-vue'

const headersPath = (field) => `domains.addDomain.domainStatus.domain_not_configured.modal.helpTable.headers.${field}`
const itemsPath = (index, field) => `domains.addDomain.domainStatus.domain_not_configured.modal.helpTable.items[${index}].${field}`

const headers = () => [
  { text: getMessage(headersPath('entry')), value: 'entry', sortable: false },
  { text: getMessage(headersPath('type')), value: 'type', sortable: false },
  { text: getMessage(headersPath('priority')), value: 'priority', sortable: false },
  { text: getMessage(headersPath('content')), value: 'content', sortable: false }
]

const items = () => [
  {
    id: 1,
    entry: getMessage(itemsPath(0, 'entry')),
    type: getMessage(itemsPath(0, 'type')),
    priority: getMessage(itemsPath(0, 'priority')),
    content: getMessage(itemsPath(0, 'content'))
  },
  {
    id: 2,
    entry: getMessage(itemsPath(1, 'entry')),
    type: getMessage(itemsPath(1, 'type')),
    priority: getMessage(itemsPath(1, 'priority')),
    content: getMessage(itemsPath(1, 'content'))
  }
]

export { headers, items }
